import { includes, isNil, maxBy } from 'lodash'

import { CURATION_CERTAINTY_THRESHOLD } from '../../common/constants'

import { DISH_FIELDS_CONFIG } from '../constants'

const computeDishCellClassName = (field, isFieldEditable, dish) => {
  let className = `field-${field}`

  if (isFieldEditable) {
    className += ' cell-editable'
  }

  let fieldCertainty
  if (
    includes(
      [
        DISH_FIELDS_CONFIG.NAME.value,
        DISH_FIELDS_CONFIG.DESCRIPTION.value,
        DISH_FIELDS_CONFIG.INGREDIENTS.value,
      ],
      field,
    )
  ) {
    const aiSuggestion = dish.aiSuggestion?.miscAndChoice?.[field]

    if (!isNil(aiSuggestion?.score)) {
      fieldCertainty = aiSuggestion.score
    }
  }

  if (
    includes(
      [
        DISH_FIELDS_CONFIG.DISH_TYPE.value,
        DISH_FIELDS_CONFIG.COURSE_TYPE.value,
        DISH_FIELDS_CONFIG.DIETS.value,
        DISH_FIELDS_CONFIG.ALLERGENS.value,
        DISH_FIELDS_CONFIG.MAIN_INGREDIENTS.value,
      ],
      field,
    )
  ) {
    const aiSuggestion = dish.aiSuggestion?.[field]
    const { certainty } = !isNil(aiSuggestion?.certainty)
      ? aiSuggestion
      : maxBy(aiSuggestion, 'score') || {}

    if (!isNil(certainty)) {
      fieldCertainty = certainty
    }
  }

  if (
    fieldCertainty < CURATION_CERTAINTY_THRESHOLD &&
    !dish?.isManualIgnored &&
    !dish?.isAiIgnored
  ) {
    className += ' cell-low-certainty'
  }

  return className
}

export default computeDishCellClassName
